<template>
  <el-popover
      ref="modal"
      v-model="visible"
      placement="left"
      width="250"
      trigger="click">
    <div style="text-align: center; margin-bottom: 20px;">
      Are you sure to cancel request <br> <b>{{ request.uuid }}</b>?
      <div style="margin: 10px 0px;">
        <el-input
            v-model="comment"
            type="textarea"
            placeholder="Add comment" />
      </div>
    </div>
    <div style="justify-content: center; display: flex;">
      <el-button
          type="primary"
          size="small"
          :disabled="!comment"
          @click="cancelRequest()">
        Confirm
      </el-button>
    </div>
    <el-button
        slot="reference"
        size="small"
        type="danger"
        :disabled="visible">
      Cancel
    </el-button>
  </el-popover>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
const { mapActions: requestActions } = h("db/requests");

export default {
  name: "CancelRequestButton",
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      comment: "",
    };
  },
  methods: {
    ...requestActions(["moveRequest"]),
    cancelRequest() {
      this.visible = false;
      this.moveRequest({
        requestId: this.request.id,
        comment: this.comment,
      }).then((response) => {
        this.$emit("reload");
      });
    },
  },
};
</script>
